import {formatTimecode} from './Utils'
export default function Timecode ({ duration, position }) {
  return (
    <span>{formatTimecode(duration, position)}</span>
  )
}
